import React from 'react';
import Countdown from 'react-countdown';

// mui
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

interface IdleWarningDialogProps {
    onClose: () => void;
    open: boolean;
    onLogout: () => void;
}

const IdleWarningDialog: React.FC<IdleWarningDialogProps> = (props) => {
    const { onClose, open, onLogout } = props;

    // Renderer callback with condition
    // @ts-ignore
    const renderer = ({ minutes, seconds, completed }) => {
        if (completed) {
            // Logout user if timer completes
            return onLogout();
        } else {
            // Render a countdown
            return (
                <span>
                    {minutes} minutes {seconds} seconds
                </span>
            );
        }
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {'Session Expiration Warning'}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Your session will expire in{' '}
                    <Countdown
                        date={Date.now() + 1000 * 60 * 2}
                        // @ts-ignore
                        renderer={renderer}
                    />
                    . Do you want to extend the session?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onLogout} color="primary">
                    Logout
                </Button>
                <Button onClick={onClose} color="primary" variant={'contained'}>
                    Continue Session
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default IdleWarningDialog;
